<template>
  <el-dialog title="箱子模板" :visible.sync="visible" width="40%">
    <el-form label-position="left" label-width="80px" :model="boxInfo">
      <el-form-item label="名称">
        <el-input maxlength='450' v-model="boxInfo.templateName"></el-input>
      </el-form-item>
      <el-form-item label="尺寸">
        <div style="display: flex">
          <el-input maxlength='450' v-model="boxInfo.length" placeholder="长度">
            <template slot="append">CM</template>
          </el-input>
          <span style="padding: 0 8px">*</span>
          <el-input maxlength='450' v-model="boxInfo.width" placeholder="宽度">
            <template slot="append">CM</template>
          </el-input>
          <span style="padding: 0 8px">*</span>
          <el-input maxlength='450' v-model="boxInfo.height" placeholder="高度">
            <template slot="append">CM</template>
          </el-input>
        </div>
      </el-form-item>
      <!-- <el-form-item label="库存数量">
        <el-input maxlength='450' v-model="boxInfo.stock"></el-input>
      </el-form-item> -->
      <el-form-item label="备注">
        <el-input maxlength='450' v-model="boxInfo.remark" type="textarea"></el-input>
      </el-form-item>
      <!--      <el-form-item label="材料类型">-->
      <!--        <el-select v-model="boxInfo.type" placeholder="请选择">-->
      <!--          <el-option-->
      <!--              v-for="item in types"-->
      <!--              :key="item.value"-->
      <!--              :label="item.label"-->
      <!--              :value="item.value">-->
      <!--          </el-option>-->
      <!--        </el-select>-->
      <!--      </el-form-item>-->
      <el-form-item>
        <div style="text-align: left">
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="visible = false">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { boxTemplatePage, addBox, editBox } from "@/apis/configure";
export default {
  name: "SetBoxTemplate",
  data() {
    return {
      visible: false,
      boxInfo: {},
      // types: [
      //   {
      //     value: 0,
      //     label: '箱子'
      //   },
      //   {
      //     value: 1,
      //     label: '袋子'
      //   }
      // ]
    };
  },
  watch: {
    visible: function (newVal) {
      if (!newVal) {
        this.boxInfo = {};
      }
    },
  },
  methods: {
    open: function (boxInfo) {
      this.visible = true;
      if (boxInfo) {
        this.boxInfo = boxInfo;
      }
    },
    onSubmit: function () {
      let params = {
        ...this.boxInfo,
      };
      if (params.boxTemplateId) {
        editBox(params).then(({code})=>{
          if(code === 0){
            this.$message.success('修改成功')
            this.visible = false
            this.$emit("submitCallback")
          }
        });
        return
      }
      addBox(params).then(({code})=>{
          if(code === 0){
            this.$message.success('添加成功')
            this.visible = false
            this.$emit("submitCallback")
          }
        });
      // this.$emit("submitCallback", { ...this.boxInfo });
    },
  },
};
</script>

<style scoped></style>
